import Axios from "../../services/axios-service";

const getRoles = data => {
  return Axios.get("/api/Roles?filters="+encodeURIComponent(JSON.stringify(data)), undefined, undefined);
};

const updateRole = data => {
  return Axios.put("/api/Roles/"+data.id, data, undefined);
};

const getRole = idx => {
  return Axios.get("/api/Roles/"+idx, undefined, undefined);
};

const deleteRole = data => {
  return Axios.delete("/roles/"+ data.id, data, undefined);
};
const addRole = data => {
  return Axios.post("/api/Roles/", data, undefined);
};

const getAllExternalRoles = data => {
  return Axios.get("/api/Roles/ExternalRoles", undefined, undefined);
};

const getAllInternalRoles = data => {
  return Axios.get("/api/Roles/InternalRoles", undefined, undefined);
};

export default {
    getRoles,
    updateRole,
    getRole,
    deleteRole,
    addRole,
    getAllExternalRoles,
    getAllInternalRoles
};
